import { NodeViewWrapper, NodeViewProps, NodeViewContent } from '@tiptap/react';

import { useDeleteEmptyDBlockOnMainInput } from './useDeleteEmptyDBlockOnMainInput';
import { PersonaNodeWrapper } from '../PersonaNodeWrapper';

export function FlowDBlockNodeView(props: NodeViewProps) {
  const { deleteNode, node } = props;

  useDeleteEmptyDBlockOnMainInput(deleteNode, node);

  // No drag grip: messages reorder via the bubble's actions menu (Move up /
  // Move down). In-editor drag was too fiddly to feel good.
  return (
    <NodeViewWrapper role="group" className="content-bubble">
      <PersonaNodeWrapper {...props}>
        <NodeViewContent />
      </PersonaNodeWrapper>
    </NodeViewWrapper>
  );
}
